export default {
    meta: {
        title: '财务管理',
        isShowNav: true,
    },
};
